const HeaderData = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Games",
    link: "/games",
  },
  {
    title: "About",
    link: "/our-story",
  },
  {
    title: "Contact",
    link: "/page/contact-simple",
  },
];

export default HeaderData;
